function FeedbackIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M7 22.848h3.273V13.03H7v9.818zm18-9c0-.9-.736-1.636-1.636-1.636H18.2l.777-3.74.025-.26c0-.336-.14-.647-.36-.868l-.867-.86-5.384 5.393a1.6 1.6 0 00-.483 1.153v8.182c0 .9.736 1.636 1.636 1.636h7.364c.68 0 1.26-.409 1.506-.998l2.47-5.768c.074-.188.115-.385.115-.597v-1.637z" />
    </svg>
  )
}

export default FeedbackIcon
